// extracted by mini-css-extract-plugin
export default {"herosBannerWrapper":"styles_herosBannerWrapper__OITHp","HerosBanner":"styles_HerosBanner__2Xpq-"};